import { Box, Container, Heading, Text, Link } from '@chakra-ui/react';
import Header from '../partials/common/header/header';
import Footer from '../partials/common/footer/footer';

function BookPage() {
    return (
        <>
            <Header />
            <Container py={20} px={{ base: 18, md: 28 }} width={"100%"} maxW={"100%"} centerContent>
                <Heading>Book Your Tour</Heading>
                <Box mt={10} textAlign="center">
                    <Text fontSize="lg" mb={4}>
                        We are excited to help you plan your next adventure!
                    </Text>
                    <Text>
                        To book a tour or package, please send us an email with your desired tour name, number of travelers, and preferred travel dates. Our team will get back to you shortly with a confirmation and further details.
                    </Text>
                    <Text mt={6} fontSize="xl" fontWeight="bold">
                        Email us at: <Link href="mailto:bookings@travelnex.in" color="brand.500">bookings@travelnex.in</Link>
                    </Text>
                    <Text mt={8}>
                        Please note that all bookings are subject to availability. We recommend booking in advance to secure your spot, especially during peak travel seasons.
                    </Text>
                    <Text mt={4}>
                        Thank you for choosing Travelnex!
                    </Text>
                </Box>
            </Container>
            <Footer />
        </>
    );
}

export default BookPage;